@if (getPersonaSelected) {
<div class="row card-nominative">
  <div class="col-lg-12 mb-2">
    <div class="d-block">
      <div class="d-flex align-items-center">
        <span class="material-symbols-outlined font-36px me-2">
          account_circle
        </span>
        <strong class="title-nominative">{{ getAttributeName(getPersonaSelected, titleNominativeAtribute) | titlecase }}
        </strong>
        @if (selectCountry === 'AR' && stateBlock) {
        <span class="material-symbols-outlined text-danger" efxTooltip efxTooltipTitle="Usuario tiene bloqueo"
          efxTooltipPlacement="right" efxTooltipMode="dark">
          block
        </span>
        }
      </div>
      <div>
        {{document}}
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="d-flex justify-content-start nominative-container flex-wrap">
      @for (c of getTableConfiguration; track c) {
      <div>
        <div class="d-block">
          <div class="nominative-title">
            {{c.title}}
          </div>
          <div class="nominative-description">
            @if (c.attributeName === 'entityKey') {
            <div class="tooltip-container d-flex">
              <div class="me-2">
                {{ getAttributeName(getPersonaSelected, c.attributeName) | titlecase }}
              </div>
              <div class="cursor-pointer"
                (click)="copyTextToClipboard(getAttributeName(getPersonaSelected, 'entityKeyTooltip'))">
                @if (showTextoCopiado) {
                <span class="material-symbols-outlined"> check_circle </span>
                }
                @if (!showTextoCopiado) {
                <span class="material-symbols-outlined">content_copy</span>
                }
              </div>
            </div>
            }
            @if ((c.attributeName === 'rut' || c.attributeName === 'documento_numero' || c.attributeName === 'documento'
            || c.attributeName === 'cedula' || c.attributeName === 'nationalId' || c.attributeName === 'documentNum' ||
            c.attributeName === 'identificador')) {
            <div class="tooltip-container d-flex align-items-center">
              <div class="me-2">
                {{ getAttributeName(getPersonaSelected, c.attributeName) === "" ? '-':
                getAttributeName(getPersonaSelected, c.attributeName) | titlecase }}
                @if (localStorageService.documentList) {
                <span class="material-symbols-outlined text-danger" efxTooltip
                  efxTooltipTitle="{{ localStorageService.documentList }}" efxTooltipPlacement="bottom"
                  efxTooltipMode="dark">
                  info
                </span>
                }
                @if (!localStorageService.documentList) {
                <span class="material-symbols-outlined text-secondary">
                  info
                </span>
                }
              </div>
            </div>
            }
            @if ((c.attributeName != 'entityKey' && c.attributeName != 'rut' && c.attributeName != 'documento_numero' &&
            c.attributeName != 'documento' && c.attributeName != 'cedula' && c.attributeName != 'nationalId' &&
            c.attributeName != 'documentNum' && c.attributeName != 'identificador')) {
            <div>
              {{ getAttributeName(getPersonaSelected, c.attributeName) === "" ? '-':getAttributeName(getPersonaSelected,
              c.attributeName) | titlecase }}
            </div>
            }
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>
}